import React, { memo, useCallback } from 'react'
import { Form, Formik } from 'formik'
import { SectionCard } from 'src/components/shared/SectionCard'
import type { HistoricalInvoicesFormValues } from './historical-invoices-form/HistoricalInvoicesForm.interface'
import { HistoricalInvoicesFormContent } from './historical-invoices-form/HistoricalInvoicesFormContent'
import { historicalInvoicesFormValidator } from './historical-invoices-form/HistoricalInvoicesForm.validator'

interface Props {
  /** Incremented by the page after a successful upload; remounts the form when it changes. */
  resetKey: number
  isUploading: boolean
  onUpload(file: File): void
}

const INITIAL_VALUES: HistoricalInvoicesFormValues = {
  file: null,
}

const HistoricalInvoicesCardComponent = ({ resetKey, isUploading, onUpload }: Props) => {
  const handleSubmit = useCallback(
    (values: HistoricalInvoicesFormValues) => {
      // The validator guarantees this; the check narrows the type for the callback.
      if (values.file === null) {
        return
      }

      onUpload(values.file)
    },
    [onUpload],
  )

  return (
    <SectionCard
      title="Historical invoices"
      subtitle="Upload this customer's past invoices as a CSV. The lender uses the repayment history when setting a credit limit."
      dataTestId="admin-customer-historical-invoices-card"
    >
      {/* `key={resetKey}` remounts the whole form after a successful upload, clearing the Formik
          values, the touched flags and the picker's own selection in one move. */}
      <Formik<HistoricalInvoicesFormValues>
        key={resetKey}
        initialValues={INITIAL_VALUES}
        validationSchema={historicalInvoicesFormValidator}
        onSubmit={handleSubmit}
      >
        <Form>
          <HistoricalInvoicesFormContent isUploading={isUploading} />
        </Form>
      </Formik>
    </SectionCard>
  )
}

export const HistoricalInvoicesCard = memo(HistoricalInvoicesCardComponent)
